let language = null;
let currency = null;
let gamePlayStatus = null;// first time launch
let jurisdiction = null;
let gameName = null;
let gameDisplayName = null;
let gameVersion = null;
let playMode = null;
let cheatMode = null;
let minSpinDuration = null;
let slowConnection = null;
let autoplayPreventingStates = null;
let sessionTime = null;
let maxWin = null;
let autoplaySpinsLimit = null;
let gameBaseURL = null;
let funBanner = null;
let closeButton = null;
let showRtpAndMaxWin = null;
let rtp = null;
let maxExposure = null;
let autoplayLevels = [];
let disableSkip = null;
let provider = null;
let errorDialogsDisabled = null;

let isInited = false;

const CheatModes = {
    Active: 'active',
    Inactive: 'inactive',
};

const PlayModes = {
    Real: 1,
    Fun: 2
}

const setConfig = (data) => {
    if (isInited) {
        console.error('PSConfig should be initialized ones');
    }
    language = data.language;
    currency = data.currency;
    gamePlayStatus = data.gamePlayStatus;
    jurisdiction = data.jurisdiction;
    gameName = data.gameName;
    gameDisplayName = data.gameDisplayName;
    gameVersion = data.gameVersion;
    playMode = data.playMode;
    cheatMode = data.cheatMode;
    minSpinDuration = data.minSpinDuration;
    slowConnection = data.slowConnection;
    autoplayPreventingStates = data.autoplayPreventingStates;
    sessionTime = data.sessionTime;
    maxWin = data.maxWin;
    autoplaySpinsLimit = data.autoplaySpinsLimit;
    autoplayLevels = data.autoplayLevels;
    gameBaseURL = data.gameBaseURL;
    funBanner = data.funBanner;
    closeButton = data.closeButton;
    maxExposure = data.maxExposure;
    rtp = data.rtp;
    showRtpAndMaxWin = data.showRtpAndMaxWin;
    disableSkip = data.disableSkip;
    provider = data.provider;
    errorDialogsDisabled = data.errorDialogsDisabled;
};

const get = () => {
    return {
        language,
        currency,
        gamePlayStatus,
        jurisdiction,
        gameName,
        gameDisplayName,
        gameVersion,
        playMode,
        cheatMode,
        minSpinDuration,
        slowConnection,
        autoplayPreventingStates,
        sessionTime,
        maxWin,
        autoplaySpinsLimit,
        autoplayLevels,
        gameBaseURL,
        funBanner,
        closeButton,
        showRtpAndMaxWin,
        rtp,
        disableSkip,
        maxExposure,
        provider,
        errorDialogsDisabled,
    };
};

export default {
    CheatModes,
    PlayModes,
    setConfig,
    get
};
